<template>
  <Menu buttonText="Register Here" />
  <main id="agenda">
    <Agendahero />
    <div class="agenda-container">
      <div class="agenda__main-title">
        <h2><b>Sequire Investor Summit</b> 2027</h2>
        <hr class="half-line">
      </div>
      <div class="agenda__tabs">
        <div class="tabs__container container">
          <button 
            class="tab__button"
            :class="{ 'tab__button--active': activeDay === 1 }"
            @click="activeDay = 1"
            data-text="Tuesday, January 19th"
          >
            Tuesday, January 19th
          </button>
          <button 
            class="tab__button"
            :class="{ 'tab__button--active': activeDay === 2 }"
            @click="activeDay = 2"
            data-text="Wednesday, January 20th"
          >
            Wednesday, January 20th
          </button>
          <button 
            class="tab__button"
            :class="{ 'tab__button--active': activeDay === 3 }"
            @click="activeDay = 3"
            data-text="Thursday, January 21st"
          >
            Thursday, January 21st
          </button>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <dayone v-if="activeDay === 1" key="day1" />
        <daytwo v-else-if="activeDay === 2" key="day2" />
        <daythree v-else-if="activeDay === 3" key="day3" />
      </transition>
    </div>
    <Cta />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/components/agenda/style.scss';
  @import '../styles/components/agenda/agenda.scss';

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
  }

  .fade-enter-from {
    opacity: 0;
    transform: translateY(20px);
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/menu';
import dayone from '@/components/agenda/day-one.vue';
import daytwo from '@/components/agenda/day-two.vue';
import daythree from '@/components/agenda/day-three.vue';
import Agendahero from '@/components/agenda/agendahero.vue';
import Cta from '@/components/cta.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    dayone,
    daytwo,
    daythree,
    Agendahero,
    Cta
  },
  data() {
    return {
      activeDay: 3
    };
  }
};
</script>